import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { SweetAlertShow, LoadingDiv } from "../master/Master";
import { useLocation, useNavigate } from "react-router-dom";
import { enquiryDetail } from "../../api/Enquiry";
import Master from "./Master";
import BasicDetail from "./tabs/BasicDetail";
import FollowUps from "./tabs/FollowUps";
import EnquiryForm from "./tabs/EnquiryForm";
import EnquiryDemoForm from "./tabs/EnquiryDemoForm";
import StatusModal from "./components/StatusModal";
import FollowUpModal from "./components/FollowUpModal";
import usePrivateLink from "../config/usePrivateLink";

export default function EnquiryDetail() {
  const [loading, setLoading] = useState("");
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const id = params.get("id") ?? "";
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({ type: "Basic" });
  const hasAccess = usePrivateLink();

  const getDataList = async () => {
    setLoading(true);
    try {
      const response = await enquiryDetail(id);
      if (response.data.status) {
        setData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDataList();
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="row">
                      <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
                          <div className="d-flex align-items-center gap-2 flex-wrap">
                            {[
                              {
                                icon: "ri-book-line",
                                type: "Basic Details",
                                link: "Basic",
                                route: "/enquiry/detail",
                              },
                              {
                                icon: "ri-pie-chart-line",
                                type: "Follow Ups",
                                link: "FollowUps",
                                route: "/enquiry/followups/view",
                              },
                              {
                                icon: "ri-government-line",
                                type: "Enquiry Form",
                                link: "EnquiryForm",
                                route: "/enquiry/form/view",
                              },
                              {
                                icon: "ri-graduation-cap-line",
                                type: "Demo Form",
                                link: "DemoForm",
                                route: "/enquiry/demo/form/view",
                              },
                            ]
                              .filter((tab) => hasAccess(tab.route))
                              .map((tab) => (
                                <button
                                  key={tab.link}
                                  className={`btn ${
                                    filters?.type === tab.link
                                      ? "btn-primary"
                                      : "btn-outline-primary"
                                  }`}
                                  onClick={() =>
                                    setFilters((prev) => ({
                                      ...prev,
                                      type: tab.link,
                                    }))
                                  }
                                >
                                  <i className={`me-2 ${tab.icon}`}></i>
                                  {tab.type}
                                </button>
                              ))}
                          </div>
                          {hasAccess("/student/documents/add") && (
                            <button
                              className="btn btn-success"
                              onClick={() =>
                                navigate(
                                  `/student/documents/add?enquiry_id=${data?.id}`,
                                )
                              }
                            >
                              <i className="ri-file-upload-line me-2"></i>
                              Add Document
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="col-12">
                        {filters?.type === "Basic" ? (
                          <>
                            <BasicDetail data={data} />
                            <StatusModal
                              data={data}
                              setData={setData}
                              setLoading={setLoading}
                              handleFunction={getDataList}
                            />
                          </>
                        ) : filters?.type === "FollowUps" ? (
                          <>
                            <FollowUps data={data} />
                            <FollowUpModal
                              data={data}
                              setLoading={setLoading}
                              handleFunction={getDataList}
                            />
                          </>
                        ) : filters?.type === "EnquiryForm" ? (
                          <EnquiryForm data={data} />
                        ) : filters?.type === "DemoForm" ? (
                          <EnquiryDemoForm data={data} />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
